(function () {
  const STORAGE_KEY = 'milk_cookie_consent_v1';
  const COOKIE_NAME = 'milk_cookie_consent';
  const COOKIE_MAX_AGE = 365 * 24 * 60 * 60;
  const CHOICE_KEYS = ['preferences', 'analytics', 'marketing'];

  const root = document.getElementById('CookieNotice');
  if (!root) return;

  const defaultConsent = () => ({
    essential: true,
    analytics: false,
    marketing: false,
    preferences: false,
  });

  function readStored() {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      if (raw) return JSON.parse(raw);
    } catch (_) {}

    try {
      const match = document.cookie.match(new RegExp('(?:^|; )' + COOKIE_NAME + '=([^;]*)'));
      if (match) return JSON.parse(decodeURIComponent(match[1]));
    } catch (_) {}

    return null;
  }

  function persist(consent) {
    const payload = { ...consent, timestamp: Date.now() };
    const json = JSON.stringify(payload);

    try {
      localStorage.setItem(STORAGE_KEY, json);
    } catch (_) {}

    document.cookie = COOKIE_NAME + '=' + encodeURIComponent(json) + '; path=/; max-age=' + COOKIE_MAX_AGE + '; SameSite=Lax';
  }

  function applyShopifyConsent(consent) {
    const tracking = {
      analytics: !!consent.analytics,
      marketing: !!consent.marketing,
      preferences: !!consent.preferences,
      sale_of_data: !!consent.marketing,
    };

    function setConsent() {
      if (window.Shopify && window.Shopify.customerPrivacy && window.Shopify.customerPrivacy.setTrackingConsent) {
        window.Shopify.customerPrivacy.setTrackingConsent(tracking, function () {});
      }
    }

    if (window.Shopify && window.Shopify.loadFeatures) {
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (error) {
        if (!error) setConsent();
      });
    } else {
      setConsent();
    }

    document.dispatchEvent(new CustomEvent('milk:cookie-consent', { detail: consent }));
  }

  function hide() {
    root.hidden = true;
    root.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('cookie-notice-open');
  }

  function show() {
    root.hidden = false;
    root.setAttribute('aria-hidden', 'false');
  }

  function setView(view) {
    root.querySelectorAll('[data-cookie-view]').forEach(function (panel) {
      panel.hidden = panel.getAttribute('data-cookie-view') !== view;
    });

    // Only the detailed "Cookie settings" view is a full-screen modal —
    // lock background scroll for that, but not for the compact banner.
    const isSettings = view === 'settings';
    root.classList.toggle('cookie-notice--settings', isSettings);
    document.documentElement.classList.toggle('cookie-notice-open', isSettings);
  }

  function setChoice(key, enabled) {
    const value = enabled ? 'yes' : 'no';

    root.querySelectorAll('[data-cookie-choice="' + key + '"]').forEach(function (button) {
      const active = button.getAttribute('data-cookie-value') === value;
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
  }

  function readChoiceValues() {
    const consent = defaultConsent();

    CHOICE_KEYS.forEach(function (key) {
      const yesButton = root.querySelector('[data-cookie-choice="' + key + '"][data-cookie-value="yes"]');
      consent[key] = !!(yesButton && yesButton.classList.contains('is-active'));
    });

    return consent;
  }

  function syncChoices(consent) {
    CHOICE_KEYS.forEach(function (key) {
      setChoice(key, !!consent[key]);
    });
  }

  function saveConsent(consent) {
    persist(consent);
    applyShopifyConsent(consent);
    hide();
  }

  root.addEventListener('click', function (event) {
    const choiceBtn = event.target.closest('[data-cookie-choice]');
    if (choiceBtn) {
      const key = choiceBtn.getAttribute('data-cookie-choice');
      const enabled = choiceBtn.getAttribute('data-cookie-value') === 'yes';
      setChoice(key, enabled);
      return;
    }

    const actionEl = event.target.closest('[data-cookie-action]');
    if (!actionEl) return;

    const action = actionEl.getAttribute('data-cookie-action');

    if (action === 'settings') {
      setView('settings');
      return;
    }

    if (action === 'back') {
      setView('main');
      return;
    }

    if (action === 'accept') {
      saveConsent({
        essential: true,
        analytics: true,
        marketing: true,
        preferences: true,
      });
      return;
    }

    if (action === 'reject') {
      saveConsent(defaultConsent());
      return;
    }

    if (action === 'save') {
      saveConsent(readChoiceValues());
    }
  });

  function openNotice(view) {
    const consent = readStored() || defaultConsent();
    syncChoices(consent);
    setView(view || 'main');
    show();
  }

  document.addEventListener('click', function (event) {
    const openEl = event.target.closest('[data-cookie-open]');
    if (!openEl) return;

    event.preventDefault();
    openNotice(openEl.getAttribute('data-cookie-open') || 'main');
  });

  window.MilkCookieNotice = {
    open: openNotice,
    openSettings: function () {
      openNotice('settings');
    },
  };

  const stored = readStored();
  if (stored) {
    applyShopifyConsent(stored);
    hide();
  } else {
    syncChoices(defaultConsent());
    setView('main');
    show();
  }
})();
